import { render, staticRenderFns } from "./applicationPolicyDeclareDetail.vue?vue&type=template&id=3f465c0f&scoped=true&"
import script from "./applicationPolicyDeclareDetail.vue?vue&type=script&lang=js&"
export * from "./applicationPolicyDeclareDetail.vue?vue&type=script&lang=js&"
import style0 from "./applicationPolicyDeclareDetail.vue?vue&type=style&index=0&id=3f465c0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f465c0f",
  null
  
)

export default component.exports